import {
  POST,
  GET,
  GETPDF,
  FILE
} from '@/axios/axios'

export const services = {
  ServiceType: (param) => { // 服务类型
    return GET("/backend/dataDict/queryInvoicingCategoryForMerchant", param);
    return GET("/backend/dataDict/queryInvoicingCategory", param);
  },
  SellerInfoPage: (param) => { // 商户信息列表
    return GET("/backend/custom/querySellerByPage", param);
  },
  SellerExport: (param, rsType) => { // 商户信息导出
    return GETPDF("/backend/custom/querySellerByPageExport", param, rsType);
  },
  EditingAlternative: (param) => { // 商户信息编辑
    return GET("/backend/custom/queryOneById", param);
  },
  SaveSellerInfo: (param) => { // 商户信息新增/编辑 保存审核
    return POST("/backend/custom/saveSeller?version=v2", param)
  },
  CreateUser: (param) => { // 新增登录账号
    return POST("/backend/user/createUser", param);
  },
  QueryCreateUser: (param) => { // 新增登录账号显示
    return GET("/backend/user/queryUserBuCustomId", param);
  },
  DelAccounts: (param) => { // 新增登录账号删除
    return POST("/backend/user/disOrEnableUser", param);
  },
  BalanceQuery: (param) => { // 余额查询列表
    return GET("/backend/account/querySellerBalanceByPage", param);
  },
  DetailsViewInfo: (param) => { // 余额明细查询列表
    return GET("/backend/accountBalanceRecord/queryBalanceRecord", param);
  },
  BalanceExport: (param, rsType) => { // 余额查询导出
    return GETPDF("/backend/account/querySellerBalanceByPageExport", param, rsType);
  },
  RecordByExport: (param, rsType) => { // 余额查询-查看明细导出
    return GETPDF("/backend/accountBalanceRecord/queryBalanceRecordByExport", param, rsType);
  },
  ServiceOfList: (param) => { // 后台获取服务商列表
    return GET("/backend/serviceMerchantRel/queryServiceOfBackand", param);
  },
  ServiceByMerchant: (param) => { // 获取商户关联服务商信息
    return GET("/backend/serviceMerchantRel/queryServiceByMerchantId", param);
  },
  EnableOrDisAble: (param) => { // 停用启用
    return GET("/backend/account/enableOrDisAble", param);
  },
  addAndSubtractCheck: (param) => { // 账户余额加扣款申请
    return POST("/backend/account/addAndSubtractCheck", param);
  },
  systemCheckList: (param) => { // 账户余额审核列表
    return GET("/backend/account/systemCheckList", param);
  },
  systemCheck: (param) => { // 账户余额审核
    return GET("/backend/account/systemCheck", param);
  },
  AddAccount: (param) => { // 新增账户 -- 系统账户
    return POST("/backend/account/addAccount", param);
  },
  BalanceQueryAli: (param) => { // 查询支付宝余额
    return GET("/backend/account/getAliBalance", param);
  },
  BalanceQueryAliSever: (param) => { // 查询支付宝 服务费记账本的余额
    return GET("/backend/account/queryServiceFeeAccountBalance", param);
  },
  addAliPayment: (param) => { //  支付宝公户加款
    return POST("/backend/accountRecharge/ali/recharge", param);
  },
  getAliPaySignStatus: (param) => {   // 支付宝授权状态查询
    return GET('/backend/account/getAliPaySignStatus', param)
  },
  disPayRecharge: (param) => { // 取消授权
    return GET("/backend/account/disPayRecharge", param)
  },
  RelevanceAgent: (param) => { // 关联代理商列表
    return GET("/backend/agentMerchantRel/querySellerAgentRelByPage", param);
  },
  AgentSelectList: (param) => { // 代理商/服务商/商户
    return GET("/backend/custom/findCustom", param);
  },
  AgentListExport: (param, rsType) => { // 代理商导出
    return GETPDF("/backend/custom/queryAgentExport", param, rsType);
  },
  CorrelationAgent: (param) => { // 关联代理商
    return POST("/backend/agentMerchantRel/agentMerchant", param);
  },
  updateAgencyPoint: (param) => { // 关联代理商
    return POST("/backend/custom/updateAgencyPoint", param);
  },
  CorrelationAgentExport: (param, rsType) => { //关联代理商导出
    return GETPDF("/backend/agentMerchantRel/querySellerAgentRelExport", param, rsType);
  },
  RelevanceService: (param) => { // 关联服务商列表
    return GET("/backend/serviceMerchantRel/querySellerServiceRelByPage", param);
  },
  Correlationprovider: (param) => { // 关联服务商
    return POST("/backend/serviceMerchantRel/serviceMerchant", param);
  },
  CorrelationproviderExport: (param, rsType) => { //关联服务商导出
    return GETPDF("/backend/serviceMerchantRel/querySellerServiceRelExport", param, rsType);
  },
  UnbindService: (param) => { // 解绑服务商
    return POST("/backend/serviceMerchantRel/UnbindServiceMerchant", param);
  },
  MerchantContract: (param) => { // 合同管理/合同回收站列表
    return GET("/backend/merchantContractRel/findMerchantContractList", param);
  },
  addContract: (param) => { // 上传合同新增/编辑
    return POST("/backend/merchantContractRel/addContract", param);
  },
  updateContract: (param) => { // 删除/恢复合同
    return POST("/backend/merchantContractRel/updateContract", param);
  },
  updateDefault: (param) => { // 设置合同是否默认
    return POST("/backend/merchantContractRel/updateContractIsDefault", param);
  },
  contractRelList: (param) => { // 合同管理列表
    return GET("/backend/serviceMerchantRel/findContractRelList", param);
  },
  findService: (param) => { // 根据商户id获取关联服务商信息
    return GET("/backend/custom/findServiceByMerchantId", param);
  },
  UploadInterface: (param) => {    // 统一上传文件接口
    return FILE("/backend/upload/uploadFiles", param);
  },
  OtainFacilitator: (param) => { // 获取服务商
    return GET("/backend/custom/findServiceByPlatNo", param);
  },
  findServiceAndBankByMerchantId: (param) => { // 根据商户id获取服务商和账户信息
    return GET("/backend/custom/findServiceAndBankByMerchantId", param);
  },
  AcquireMerchant: () => { // 获取商户
    return GET("/backend/custom/findMerchantByPlatNo");
  },
  findMerchantByAmount: () => { // 商户退款获取商户 ,退款申请
    return GET("/backend/custom/findMerchantByAmount");
  },
  queryCustomerBusiness: (param) => { // 获取业务列表；
    return GET("/backend/customBusiness/findBusinessInfo", param);
  },
  bindCustom: (param) => {  // 商户绑定客户经理
    return POST("/backend/customBusiness/saveCustomBusiness", param);
  },
  addCustomerBusiness: (param) => { // 添加/编辑业务员  客户经理
    return POST("/backend/custom/saveBusiness", param);
  },
  editAdoptIps: (param) => { // 修改IP白名单
    return POST("/backend/customExtra/updateIpAddress", param);
  },
  GetAccountsByCustomId: (param) => { // 获取商户下所有账户
    return GET("/backend/userAccountRel/getAccountsByCustomId", param);
  },
  BindAccountsByUserId: (param) => { // 账号 绑定 账户 批量绑定和解绑
    return POST("/backend/userAccountRel/bindUserAndAccount", param);
  },
  UnBindAccountsByUserId: (param) => { // 账号单个解绑账户
    return POST("/backend/userAccountRel/unBindUserAndAccount", param);
  },
  SingleBindUserAndAccount: (param) => { // 账号单个绑定账户
    return POST("/backend/userAccountRel/singleBindUserAndAccount", param);
  },
  CustomCheckList: (param) => { //  获取操作员商户更改信息列表
    return GET("/backend/customCheck/queryByPage", param);
  },
  CustomCheckExamine: (param) => { // 审核操作员 更改商户信息 状态
    return POST("/backend/customCheck/checked", param);
  },
  findAccountAndAli: (param) => { // 审核操作员 更改商户信息 状态
    return GET("/backend/user/dls/findAccountAndAli", param);
  },
  rechargeDetails: (param) => { // 惠通明细
    return GET("/backend/account/getRechargeDetailsHt", param);
  },
  addServiceAccount: (param) => { // 服务商创建支付宝账户
    return POST("/backend/account/addServiceAccount", param);
  },
  applyAuthorization: (param) => { // 服务商支付宝授权
    return GET("/backend/account/service/applyAliPayAuthorization", param);
  },
  changeParent: (param) => { // 变更登录主账号
    return GET("/backend/custom/changeParent", param);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/sellerInfo.js